/**
 * Zjednodušená konfigurace – kategorie a enginy odstraněny.
 * Nahrazeno generativní poptávkou (jeden chat pro všechny stavební služby).
 */

export function getEngineLabel(_engineId: string | null | undefined): string {
  return "Všechny";
}

/** Prázdné pole – engine filtr v adminu zobrazuje jen "Všechny" */
export const ALL_SERVICES: { id: string; label: string; engineId?: string }[] = [];
